import React from 'react';

function HomePage() {
  return (
    <div>
      <h2>Welcome to SLP Sidekick!</h2>
      <p>
        Select an exercise from the menu on the left to get started.
      </p>
      <p>
        You can adjust settings like the voice used for audio feedback by clicking the settings <span role="img" aria-label="settings icon">⚙️</span> icon in the top right.
      </p>
    </div>
  );
}

export default HomePage;

